import { useEffect, useRef, useState } from 'react';
import CourseCard from './CourseCard';

const CoursesList = () => {
  const courses = [
    {
      id: 1,
      sno: 1,
      instructor: 'DR.FATİH RASİM',
      title: 'ANTERİOR KIRIKLARIN ESTETİK VE FONKSİYONEL RESTORASYONU KOMPOZİT METERYALLER İLE DİASTEMA KAPATMA',
      date: '3 MAYIS 2026',
      session: 'Öğleden Önce',
      capacity: 20,
      isPending: false,
    },
    {
      id: 2,
      sno: 2,
      instructor: 'DT.EMRECAN EREN',
      title: 'KLİNİK DİJİTAL İŞ AKIŞINDA 3D PRİNTER İLE ÜRETİLEN GEÇİCİ VE DAİMİ RESTORASYONLAR',
      date: '3 MAYIS 2026',
      session: 'Öğleden Önce',
      capacity: 20,
      isPending: false,
    },
    {
      id: 3,
      sno: 3,
      instructor: 'DOÇ.DR.AYFER ATAV & DR.EMRE ÖVSAY',
      title: 'RISING: ENDODONTİK ŞEKİLLENDİRMEDE YENİ BİR EVRİM',
      date: '3 MAYIS 2026',
      session: 'Öğleden Önce',
      capacity: 20,
      isPending: false,
    },
    {
      id: 4,
      sno: 4,
      instructor: 'PROF.DR.EZHER DAYISOYLU',
      title: 'TEMEL İMPLANTOLOJİ',
      date: '3 MAYIS 2026',
      session: 'Öğleden Önce',
      capacity: 20,
      isPending: false,
    },
    {
      id: 5,
      sno: 5,
      instructor: 'DT.SELİM CAN DÖNEL',
      title: 'DİŞ HEKİMLİĞİ KLİNİĞİNDE BOTULİNUM TOKSİN UYGULAMALARI',
      date: '3 MAYIS 2026',
      session: 'Öğleden Sonra',
      capacity: 20,
      isPending: false,
    },
    {
      id: 6,
      sno: 6,
      instructor: 'DR.FATİH RASİM',
      title: 'ANTERİOR KIRIKLARIN ESTETİK VE FONKSİYONEL RESTORASYONU KOMPOZİT METERYALLER İLE DİASTEMA KAPATMA',
      date: '3 MAYIS 2026',
      session: 'Öğleden Sonra',
      capacity: 20,
      isPending: false,
    },
    {
      id: 7,
      sno: 7,
      instructor: 'DOÇ.DR.AYFER ATAV & DR.EMRE ÖVSAY',
      title: 'RISING: ENDODONTİK ŞEKİLLENDİRMEDE YENİ BİR EVRİM',
      date: '3 MAYIS 2026',
      session: 'Öğleden Sonra',
      capacity: 20,
      isPending: false,
    },
    {
      id: 8,
      sno: 8,
      instructor: 'PROF.DR.EZHER DAYISOYLU',
      title: 'TEMEL İMPLANTOLOJİ',
      date: '3 MAYIS 2026',
      session: 'Öğleden Sonra',
      capacity: 20,
      isPending: false,
    },
  ];

  const day1Morning = courses.filter(c => c.date === '3 MAYIS 2026' && c.session === 'Öğleden Önce');
  const day1Afternoon = courses.filter(c => c.date === '3 MAYIS 2026' && c.session === 'Öğleden Sonra');

  const SectionTitle = ({ icon, label, sub }: { icon: string; label: string; sub: string }) => (
    <div className="flex items-center gap-4 mb-6">
      <div className="w-11 h-11 flex items-center justify-center bg-[#0D1B3E] rounded-xl">
        <i className={`${icon} text-xl text-[#C9A84C]`}></i>
      </div>
      <div>
        <h2 className="text-xl font-bold text-[#0D1B3E]">{label}</h2>
        <p className="text-gray-500 text-sm">{sub}</p>
      </div>
    </div>
  );

  return (
    <div className="py-16 bg-[#f8f7f4]">
      <div className="max-w-[1200px] mx-auto px-6">

        {/* Tablo başlığı */}
        <div className="grid grid-cols-5 gap-3 px-4 mb-3 text-xs font-bold text-gray-400 uppercase tracking-widest">
          <div className="col-span-1">S.No</div>
          <div className="col-span-2">Konuşmacı & Konu</div>
          <div className="col-span-1">Tarih & Seans</div>
          <div className="col-span-1">Kontenjan</div>
        </div>

        {/* 3 Mayıs — Öğleden Önce */}
        <div className="mb-12">
          <SectionTitle icon="ri-sun-line" label="3 Mayıs 2026 — Öğleden Önce" sub="Sabah seansı kursları" />
          <div className="flex flex-col gap-4">
            {day1Morning.map((course, idx) => (
              <CourseCard key={course.id} course={course} index={idx} />
            ))}
          </div>
        </div>

        {/* 3 Mayıs — Öğleden Sonra */}
        <div className="mb-12">
          <SectionTitle icon="ri-sun-cloudy-line" label="3 Mayıs 2026 — Öğleden Sonra" sub="Öğleden sonra seansı kursları" />
          <div className="flex flex-col gap-4">
            {day1Afternoon.map((course, idx) => (
              <CourseCard key={course.id} course={course} index={idx} />
            ))}
          </div>
        </div>

        {/* Bilgilendirme kutusu */}
        <div className="bg-white rounded-2xl border border-[#C9A84C]/30 p-8 flex items-start gap-5">
          <div className="w-12 h-12 flex items-center justify-center bg-[#C9A84C]/10 rounded-xl flex-shrink-0">
            <i className="ri-information-line text-2xl text-[#C9A84C]"></i>
          </div>
          <div>
            <h3 className="text-lg font-bold text-[#0D1B3E] mb-3">Önemli Bilgiler</h3>
            <ul className="space-y-2 text-gray-600 text-sm">
              <li className="flex items-start gap-2">
                <i className="ri-checkbox-circle-fill text-[#C9A84C] mt-0.5"></i>
                <span>Her kurs için kontenjan <strong>20 kişi</strong> ile sınırlıdır.</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-checkbox-circle-fill text-[#C9A84C] mt-0.5"></i>
                <span>3 Mayıs 2026 tarinde İstanbul Atlas Üniversitesi kongre merkezinde gerçekleşecektir</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-checkbox-circle-fill text-[#C9A84C] mt-0.5"></i>
                <span>Kayıt ve detaylı bilgi için lütfen kayıt sayfasını ziyaret ediniz.</span>
              </li>
            </ul>
          </div>
        </div>

      </div>
    </div>
  );
};

export default CoursesList;